import React from 'react';
import { HelpCenterHeader } from './HelpCenterHeader';
import { Container } from './styles';
import { HelpCenterFooter } from './HelpCenterFooter';

export const Layout = ({ children }: { children: React.ReactNode }) => {
  return (
    <Container>
      <HelpCenterHeader />
      {children}
      <HelpCenterFooter />
    </Container>
  );
};
